import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const COLOR_VIOLET_50 = '#EEEEFD';
const COLOR_GREY_100 = '#EEEEEE';

// CON-1679: a failed message no longer tints the bubble red or gives it a red
// border. That treatment coloured the whole message and read as "something is
// wrong with your account", when the actual claim is far narrower: this one
// text did not reach this one contact. The failure is still stated plainly --
// red caption, red error icon, and the explanation on hover -- directly beneath
// the bubble, which is where it belongs. The isError prop is gone rather than
// left inert so nothing re-attaches styling to it by accident.
const CustomBox = styled(Box, {
  shouldForwardProp: (prop) => !['isUser', 'isDeleted', 'isScheduled'].includes(prop),
})(({
  isScheduled,
  isUser,
  theme,
}) => {
  let backgroundColor;

  if (isScheduled) {
    backgroundColor = COLOR_GREY_100;
  } else {
    backgroundColor = isUser ? COLOR_VIOLET_50 : 'white';
  }

  return {
    backgroundColor,
    borderRadius: isUser ? '8px 0px 8px 8px' : '0px 8px 8px 8px',
    boxShadow: theme.shadows[1],
  };
});

function MessageBody({
  isUser,
  isScheduled,
  children,
  ...props
}) {
  return (
    <CustomBox
      isUser={isUser}
      isScheduled={isScheduled}
      {...props}
    >
      {children}
    </CustomBox>
  );
}

MessageBody.propTypes = {
  children: PropTypes.node,
  isScheduled: PropTypes.bool,
  isUser: PropTypes.bool
};

MessageBody.defaultProps = {
  children: null,
  isScheduled: false,
  isUser: false
};

export default MessageBody;
